import React from 'react';
import { COMPONENT_TYPES } from '../../../constants';
import FixedBgTextEditor from './FixedBgText.editor';
import FixedBgTextProperties from './FixedBgText.properties';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { FixedBgTextSkinnable } from './FixedBgTextSkinnable';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { FixedBgTextProps } from './FixedBgText.types';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(FixedBgTextSkinnable);

// 외부 스킨 지원을 위한 래퍼 컴포넌트
const FixedBgTextWrapper: React.FC<FixedBgTextProps> = (props) => {
  // Ensure skin is always a string and default to 'basic'
  let selectedSkin: string | number = props.componentProps?.skin || 'basic';
  
  // Convert numeric skin to string if needed
  if (typeof selectedSkin === 'number') {
    selectedSkin = String(selectedSkin);
  }
  
  // Force 'basic' if skin is invalid
  if (!selectedSkin || selectedSkin === '') {
    selectedSkin = 'basic';
  }
  
  // Debug logging

  // ComponentData 구성
  const componentData = {
    id: props.id || `${COMPONENT_TYPES.FIXED_BG_TEXT}-${Date.now()}`,
    type: COMPONENT_TYPES.FIXED_BG_TEXT,
    props: props,
    componentProps: props.componentProps || {},
    content: props.content,
    style: props.style,
    viewMode: props.viewMode || 'pc',
    imageUrl: props.imageUrl,
    title: props.title,
    description: props.description,
    debug: props.debug,
    isPreview: props.isPreview,
    externalSkin: props.externalSkin
  };
  
  // 렌더 모드 결정
  const mode = props.isPreview ? 'preview' : 'production';
  
  // 에디터 props (필요한 경우)
  const editorProps = (props as any).isEditor ? {
    isSelected: (props as any).isSelected || false,
    onSelect: (props as any).onSelect || (() => {}),
    onEdit: (props as any).onEdit || (() => {}),
    onDelete: (props as any).onDelete || (() => {})
  } : undefined;
  
  return (
    <ComponentSkinWrapper 
      component={FixedBgTextSkinnable}
      componentData={componentData}
      skinId={selectedSkin}
      mode={mode}
      editorProps={editorProps}
    />
  );
};

// 레거시 호환성을 위한 기존 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.FIXED_BG_TEXT,
  component: FixedBgTextWrapper,
  editorComponent: FixedBgTextEditor,
  properties: FixedBgTextProperties,
  defaultProps: {
    componentProps: {
      bgImageUrl: 'https://via.placeholder.com/1920x1080',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
      textColor: '#ffffff',
      contentAlignment: 'center',
      height: 500,
      skin: 'basic'
    },
    style: {
      width: '100%',
      margin: '0 auto',
      boxSizing: 'border-box',
      position: 'relative'
    },
    content: '<h2>멋진 배경 이미지 제목</h2><p>여기에 텍스트를 추가하세요.</p>'
  },
  category: 'content',
  icon: '🖼️',
  name: '고정 배경 텍스트',
  skinnable: FixedBgTextSkinnable
});

// 컴포넌트 및 타입 내보내기
export { FixedBgTextWrapper as FixedBgTextComponent };
export { default as FixedBgTextEditor } from './FixedBgText.editor';
export { default as FixedBgTextProperties } from './FixedBgText.properties';
export * from './FixedBgText.types';
export { FixedBgTextSkinnable }; 